import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const apiClient = axios.create({
  baseURL: API_BASE,
  timeout: 60000,
  maxBodyLength: 500 * 1024 * 1024, // 500MB
  maxContentLength: 500 * 1024 * 1024,
});

/**
 * Upload a 3D model file
 */
export const uploadModel = async (file) => {
  const formData = new FormData();
  formData.append('model', file);

  try {
    const response = await apiClient.post('/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.error || error.message);
  }
};

/**
 * Generate edits based on prompt
 */
export const generateEdit = async (filename, prompt) => {
  try {
    const response = await apiClient.post('/edit', {
      filename,
      prompt,
      sessionId: Date.now().toString(),
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.error || error.message);
  }
};

/**
 * Download edited model
 */
export const downloadModel = async (filename) => {
  try {
    const response = await apiClient.get(`/download/${filename}`, {
      responseType: 'blob',
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.error || error.message);
  }
};

export default apiClient;
